export const INTERNAL_DECORATION_FILTERS = Object.freeze({
  ALL: "all",
  EXTERNAL_ONLY: "external_only",
  INTERNAL_ONLY: "internal_only",
});

export const isInternalDecorationBill = (bill = {}) => {
  const row = bill?.bill && typeof bill.bill === "object" ? bill.bill : bill;
  return row?.isInternalDecoration === true || row?.isInternalDecorationBill === true;
};

export const getBillInvoiceNumberDisplay = (bill = {}) => {
  const invoiceNumber = String(bill?.invoice || "").trim();
  if (invoiceNumber) {
    return { label: invoiceNumber, missing: false, notApplicable: false };
  }
  if (isInternalDecorationBill(bill)) {
    return { label: "N/A", missing: false, notApplicable: true };
  }
  return { label: "Missing invoice #", missing: true, notApplicable: false };
};

export const canOpenBillFromInvoiceNumber = (bill = {}) => {
  const display = getBillInvoiceNumberDisplay(bill);
  const normalizedLabel = String(display.label || "").trim().toLowerCase();
  return Boolean(
    bill?.orderId &&
    bill?.billId &&
    !display.missing &&
    !display.notApplicable &&
    normalizedLabel &&
    normalizedLabel !== "n/a"
  );
};

export const filterBillsByInternalDecoration = (bills = [], filter = INTERNAL_DECORATION_FILTERS.ALL) => {
  const safeBills = Array.isArray(bills) ? bills : [];
  if (filter === INTERNAL_DECORATION_FILTERS.EXTERNAL_ONLY) {
    return safeBills.filter((bill) => !isInternalDecorationBill(bill));
  }
  if (filter === INTERNAL_DECORATION_FILTERS.INTERNAL_ONLY) {
    return safeBills.filter((bill) => isInternalDecorationBill(bill));
  }
  return safeBills;
};

export const countMissingBillInvoiceNumbers = (bills = []) =>
  (Array.isArray(bills) ? bills : []).filter((bill) => getBillInvoiceNumberDisplay(bill).missing).length;
